import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo_picnic_v1.png'


const _hoisted_1 = { class: "wrapper" }

import "./assets/main.css";
import { RouterLink, RouterView } from "vue-router";
import HeaderText from "./components/HeaderText.vue";
import PageFooters from "./components/PageFooters.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("a", {
          class: "logo",
          href: "/"
        }, [
          _createElementVNode("img", {
            alt: "PICNIC logo",
            class: "logo",
            height: "125",
            src: _imports_0,
            width: "200"
          })
        ], -1)),
        _createVNode(HeaderText, { msg: "PICNIC (Proteins Involved in CoNdensates In Cells)" }),
        _createElementVNode("nav", null, [
          _createVNode(_unref(RouterLink), { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), { to: "/calculate" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Calculate score", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), { to: "/browse" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Browse data", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), { to: "/about-us" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("About", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), { to: "/help" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Help", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_unref(RouterView))
      ]),
      _: 1
    })),
    _createVNode(PageFooters)
  ], 64))
}
}

})